import styled from 'styled-components'

interface StyledDetailWrapperProps {
  $main: boolean
}

export const StyledDetailWrapper = styled.div<StyledDetailWrapperProps>`
  ${({ $main }) => $main && `
    &:not(:first-child) {
      margin-top: 24px;
    }
  `}
`
